<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('common.hot')"
    class="order-hot-filter"
    optional
  >
    <RygenBooleanDropdown
      :id="inputId"
      v-model="internalValue.hot"
      append-to="body"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';

import { OrderSearchCriteria } from '@/model';

import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import RygenBooleanDropdown from '@rygen/rygen-ui/components/form/RygenBooleanDropdown.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: OrderSearchCriteria,
    default: () => new OrderSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: OrderSearchCriteria): void;
}>();
const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<OrderSearchCriteria>) =>
    new OrderSearchCriteria(opts),
});
</script>
